export enum EnumProrrateo {
  SinProrrateo = 1,
  ProrrateoPlano,
  ProrrateoPlanoPeriodos,
  PerfiladoHorarioPeaje,
  PerfiladoDiarioPeaje,
  PerfiladoMixtoCuartoHorarioPeaje,
  PerfiladoCuartoHorarioPeaje
}
